export const formatCardNumber2 = (number: string) => {
  if (number)
    if (number.length <= 4) {
      return number;
    } else {
      const firstTwo = number.slice(0, 2);
      const lastTwo = number.slice(-2);
      const masked = '*'.repeat(number.length - 4); // 生成掩碼
      return `${firstTwo}${masked}${lastTwo}`; // 返回格式化的卡號
    }
};

export const formatCardNumber4 = (number: string) => {
  if (number) {
    const cleaned = number.replace(/\s/g, '');
    if (!cleaned) return '';
    if (cleaned.length <= 8) {
      return number;
    } else {
      const firstTwo = cleaned.slice(0, 4);
      const lastTwo = cleaned.slice(-4);
      const masked = '*'.repeat(cleaned.length - 8); // 生成掩碼
      return `${firstTwo}${masked}${lastTwo}`; // 返回格式化的卡號
    }
  }
};

export const formatIdlast5 = (number: string) => {
  if (number)
    if (number.length <= 5) {
      return number;
    } else {
      const firstTwo = number.slice(0, number.length - 5);
      const masked = '*'.repeat(5); // 生成掩碼
      return `${firstTwo}${masked}`; // 返回格式化的卡號
    }
};
